export const DIRT_TYPES = {
  DUP_ROWS: 'FULL_DUP_ROWS',
  EMPTY_ROWS: 'EMPTY_ROWS',
  TRIM_WHITESPACE: 'TRIM_WHITESPACE',
  DATE_FORMAT: 'DATE_FORMAT',
  CASING_FORMAT: 'CASING_FORMAT',
  PERCENTAGE_VALUES: 'PERCENTAGE_VALUES',
  MISSING_VALUES: 'MISSING_VALUES',
  SINGLE_CURRENCY_FORMAT: 'SINGLE_CURRENCY_FORMAT',
  ANONYMIZATION: 'ANONYMIZATION',
  DATA_VARIATIONS: 'DATA_VARIATIONS',
  MULTI_CURRENCY_FORMAT: 'MULTI_CURRENCY_FORMAT',
  ESCAPE_CHARACTERS: 'ESCAPE_CHARACTERS'
};

export const getCleanLabel = (type: string) => {
  switch (type) {
    case DIRT_TYPES.DUP_ROWS:
      return 'Duplicate Rows';
    case DIRT_TYPES.EMPTY_ROWS:
      return 'Empty Rows';
    case DIRT_TYPES.TRIM_WHITESPACE:
      return 'Unnecessary White spaces';
    case DIRT_TYPES.DATE_FORMAT:
      return 'Inconsistent Date Formats';
    case DIRT_TYPES.CASING_FORMAT:
      return 'Inconsistent Text Casing';
    case DIRT_TYPES.PERCENTAGE_VALUES:
      return 'Non % Values';
    case DIRT_TYPES.MISSING_VALUES:
      return 'Ignored values';
    case DIRT_TYPES.SINGLE_CURRENCY_FORMAT:
      return 'Currency added to Name';
    case DIRT_TYPES.ANONYMIZATION:
      return 'Anonymise data';
    case DIRT_TYPES.DATA_VARIATIONS:
      return 'Multi-variations for same Text';
    case DIRT_TYPES.MULTI_CURRENCY_FORMAT:
      return 'Multi Currency detected';
    case DIRT_TYPES.ESCAPE_CHARACTERS:
      return 'Line Codes';
    default:
      return type;
  }
};

export const getLabelColor = (type: string) => {
  switch (type) {
    case DIRT_TYPES.DUP_ROWS:
      return '#b2f2bb';
    case DIRT_TYPES.EMPTY_ROWS:
      return '#f9e8c2';
    case DIRT_TYPES.TRIM_WHITESPACE:
      return '#b6c4ff';
    case DIRT_TYPES.DATE_FORMAT:
      return '#f0c9e2';
    case DIRT_TYPES.CASING_FORMAT:
      return '#f8d5c3';
    case DIRT_TYPES.PERCENTAGE_VALUES:
      return '#d0e6a5';
    case DIRT_TYPES.MISSING_VALUES:
      return '#c7f3ff';
    case DIRT_TYPES.SINGLE_CURRENCY_FORMAT:
      return '#e3c6f1';
    case DIRT_TYPES.ANONYMIZATION:
      return '#eebefa';
    case DIRT_TYPES.DATA_VARIATIONS:
      return '#ffe5d1';
    default:
      return '#d2f5e0';
  }
};

export const getFontBorderColor = (type: string) => {
  switch (type) {
    case DIRT_TYPES.DUP_ROWS:
      return '#2f9e44';
    case DIRT_TYPES.EMPTY_ROWS:
      return '#c49340';
    case DIRT_TYPES.TRIM_WHITESPACE:
      return '#2e3a9a';
    case DIRT_TYPES.DATE_FORMAT:
      return '#a63e71';
    case DIRT_TYPES.CASING_FORMAT:
      return '#c05a44';
    case DIRT_TYPES.PERCENTAGE_VALUES:
      return '#6a8b25';
    case DIRT_TYPES.MISSING_VALUES:
      return '#1b90b5';
    case DIRT_TYPES.SINGLE_CURRENCY_FORMAT:
      return '#7c2d92';
    case DIRT_TYPES.ANONYMIZATION:
      return '#1971c2';
    case DIRT_TYPES.DATA_VARIATIONS:
      return '#bd602f';
    default:
      return '#47a17e';
  }
};

export const getTableFooterText = (type: string) => {
  switch (type) {
    case DIRT_TYPES.DUP_ROWS:
      return 'Removes fully duplicate rows for accurate analysis. (Only the first 25 duplicate rows are shown here)';
    case DIRT_TYPES.EMPTY_ROWS:
      return 'Remove empty rows from the file. Prevents partial data analysis.';
    case DIRT_TYPES.TRIM_WHITESPACE:
      return 'Trim white spaces before/after cell data. Ensures unique values in charts.';
    case DIRT_TYPES.DATE_FORMAT:
      return 'Standardises multiple date formats. Ensures accurate timeline charts.';
    case DIRT_TYPES.CASING_FORMAT:
      return 'Suggest standardisation for multiple casings in a column. Ensures label consistency in charts.';
    case DIRT_TYPES.PERCENTAGE_VALUES:
      return 'Extract % symbols from percentage columns and remove non-percentage values. Eliminates unwanted data in Number charts.';
    case DIRT_TYPES.MISSING_VALUES:
      return 'Mark values like "-", "n/a", "nil" as empty. Ensures clean identification of empty data in a chart.';
    case DIRT_TYPES.SINGLE_CURRENCY_FORMAT:
      return 'Extract currency symbols for easier histogram creation.';
    case DIRT_TYPES.ANONYMIZATION:
      return 'Anonymize sensitive data like names, credit card info, and email IDs. Keeps shared data private.';
    case DIRT_TYPES.DATA_VARIATIONS:
      return 'Standardise casing for values with different casings (e.g., "she likes-icecream", "She likes ice-cream"). Prevents duplicate chart values.';
    case DIRT_TYPES.MULTI_CURRENCY_FORMAT:
      return 'Convert values to a chosen currency if multiple currencies are detected. Ensures data consistency in a single base currency.';
    default:
      return '';
  }
};

export const getLabelCount = (type: string, count: number) => {
  switch (type) {
    case DIRT_TYPES.DUP_ROWS:
      return `(${count} found)`;
    case DIRT_TYPES.EMPTY_ROWS:
      return `(${count} found)`;
    case DIRT_TYPES.TRIM_WHITESPACE:
      return `(${count} found)`;
    case DIRT_TYPES.DATE_FORMAT:
      return `(${count} formats found)`;
    case DIRT_TYPES.CASING_FORMAT:
      return `(${count} types found)`;
    case DIRT_TYPES.PERCENTAGE_VALUES:
      return `(${count} such values found)`;
    case DIRT_TYPES.MISSING_VALUES:
      return `(${count} such values found)`;
    case DIRT_TYPES.SINGLE_CURRENCY_FORMAT:
      return '';
    case DIRT_TYPES.ANONYMIZATION:
      return `(${count} sensitive data column imported)`;
    case DIRT_TYPES.DATA_VARIATIONS:
      return `(${count} values found)`;
    case DIRT_TYPES.MULTI_CURRENCY_FORMAT:
      return `(${count} formats found)`;
    default:
      return '';
  }
};
